export default __webpack_public_path__ + "static/media/like.09d2ae96.svg";